import { render, staticRenderFns } from "./EvaluationList.vue?vue&type=template&id=9ff45072&scoped=true&"
import script from "./EvaluationList.vue?vue&type=script&lang=js&"
export * from "./EvaluationList.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationList.vue?vue&type=style&index=0&id=9ff45072&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff45072",
  null
  
)

export default component.exports